import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { TrendingUpIcon, UsersIcon, HeartIcon, DollarSignIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="w-full py-20 md:py-32 px-4 md:px-5" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <ScrollReveal data-id="element-110">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-center mb-4" data-id="element-111">
            Lo que cambia cuando dominas{' '}
            <span className="text-accent" data-id="element-112">el primer segundo</span>
          </h2>
          <p className="text-lg text-neutral-400 text-center mb-14 max-w-xl mx-auto" data-id="element-113">
            No es magia. Es tener el gancho correcto antes de darle REC.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-114">
          {/* Más vistas */}
          <ScrollReveal delay={0.05} data-id="element-115">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 h-full" data-id="element-116">
              <div className="w-12 h-12 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center mb-5" data-id="element-117">
                <TrendingUpIcon className="w-6 h-6 text-accent" data-id="element-118" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-119">Más vistas</h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-120">
                Tus Reels dejan de morir en 200 views. El gancho correcto hace
                que Meta los empuje.
              </p>
            </div>
          </ScrollReveal>

          {/* Más seguidores */}
          <ScrollReveal delay={0.1} data-id="element-121">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 h-full" data-id="element-122">
              <div className="w-12 h-12 rounded-xl bg-neon/10 border border-neon/20 flex items-center justify-center mb-5" data-id="element-123">
                <UsersIcon className="w-6 h-6 text-neon" data-id="element-124" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-125">
                Más seguidores
              </h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-126">
                La gente se queda, ve el video completo, y te sigue. Así
                funciona el algoritmo.
              </p>
            </div>
          </ScrollReveal>

          {/* Más engagement */}
          <ScrollReveal delay={0.15} data-id="element-127">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 h-full" data-id="element-128">
              <div className="w-12 h-12 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center mb-5" data-id="element-129">
                <HeartIcon className="w-6 h-6 text-red-400" data-id="element-130" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-131">
                Más engagement
              </h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-132">
                Comentarios, shares, guardados. Cuando enganchas, la gente
                interactúa.
              </p>
            </div>
          </ScrollReveal>

          {/* Más ventas */}
          <ScrollReveal delay={0.2} data-id="element-133">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 h-full" data-id="element-134">
              <div className="w-12 h-12 rounded-xl bg-accent-light/10 border border-accent-light/20 flex items-center justify-center mb-5" data-id="element-135">
                <DollarSignIcon className="w-6 h-6 text-accent-light" data-id="element-136" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-137">Más ventas</h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-138">
                Tu contenido por fin convierte. Porque si ven el video completo,
                ven tu oferta.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}